export default "__VITE_ASSET__a9707116__"